require('./bootstrap');

module.exports = {

    sendAjax: function (url, method, data, callback, errorHandler, viewElements = null) {
        $.ajax({
            url: url,
            method: method,
            data: data,
            processData: false,
            contentType: false,
            success: function (response) {
                callback(response, viewElements);
            },
            error: function (error) {
                if (errorHandler) {
                    errorHandler(error, viewElements);
                } else {
                    console.log(error);
                }
            }
        });
    },

    success: function (response, viewElements = null) {

        if (response.redirect) {
            window.location.href = response.redirect;
        }

        if (response.reload) {
            // window.location = window.location;
            window.location.reload();
        }

        if (response.error) {
            if (viewElements && viewElements.hasOwnProperty('modal')) {
                viewElements.modal.modal('hide');
                window.location = window.location;
            }
        }

        if (response.success == false && ('response' in response)) {

            let button = viewElements.button;

            if (button.length > 0) {
                button.prop('disabled', false);
            }

            let message = "<p class='mb-0'>" + response.response.error.message + "</p>";
            let messageContainer = '<div class="alert alert-danger alert-dismissible fade show" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + message + '</div>';
            $(messageContainer).appendTo('#errorContainer');

            button.html("Submit Payment");

            viewElements.modal.modal('hide');
            window.scrollTo(0, 0);
            window.location.reload();
            return;
        }

        if (response.errors) {

            let button = $('form').closest('form:has button:submit').find('form button:submit');

            if (button.length > 0) {
                button.prop('disabled', false);
            }

            $.each(response.errors, function (key, value) {
                $.each(value, function (k, v) {
                    let message = "<p class='mb-0'>" + v + "</p>";
                    let messageContainer = '<div class="alert alert-danger alert-dismissible fade show" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + message + '</div>';
                    $(messageContainer).appendTo('#errorContainer');
                });
            });
            button.html("Submit");
            window.scrollTo(0, 0);
        }

        if (response.success && viewElements && viewElements.hasOwnProperty('modal')) {
            window.location = window.location;
            window.location.reload();
        }
    },

    errors: function (errors, viewElements = null) {
        if (viewElements && viewElements.hasOwnProperty('modal')) {
            if (viewElements.hasOwnProperty('button')) {
                let button = viewElements.button;
                button.prop('disabled', false);
                button.html("Submit");
            }

            let modal = viewElements.modal;
            modal.modal('hide');
        }

        if (errors.hasOwnProperty('responseJSON')) {
            alert(errors.responseJSON.message)
        }
    }
}
